<p-confirmpopup #cp>
  <ng-template #content let-message>
    <div class="cont-confirm">
      <span class="confirm-msg">{{ message.message | translate }}</span>
      <div class="btn-footer">
        <p-button class="btn-secondary" [label]="'Cancel' | translate" [text]="true" (click)="cp.onReject()">
          <i class="material-symbols-outlined"> close </i>
        </p-button>
        <p-button class="btn-primary" [label]="'Confirm' | translate" (click)="cp.onAccept()">
          <i class="material-symbols-outlined"> check </i>
        </p-button>
      </div>
    </div>
  </ng-template>
</p-confirmpopup>
